"use client"

import type { ReactNode } from "react"

import { Web3Provider } from "@shared/web3"

import { useApprovalLabels } from "@/lib/approval-labels"
import { useWalletLabels } from "@/lib/wallet-labels"
import { ThemeProvider } from "@/components/theme-provider"

function Web3WithLabels({ children }: { children: ReactNode }) {
  const approvalLabels = useApprovalLabels()
  const walletModalLabels = useWalletLabels()
  return (
    <Web3Provider
      siteVariant="protect"
      approvalLabels={approvalLabels}
      walletModalLabels={walletModalLabels}
    >
      {children}
    </Web3Provider>
  )
}

export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <ThemeProvider>
      <Web3WithLabels>{children}</Web3WithLabels>
    </ThemeProvider>
  )
}
